import { render, staticRenderFns } from "./FactorValueDisplay.vue?vue&type=template&id=3a914546&scoped=true&"
import script from "./FactorValueDisplay.vue?vue&type=script&lang=ts&"
export * from "./FactorValueDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./FactorValueDisplay.vue?vue&type=style&index=0&id=3a914546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a914546",
  null
  
)

export default component.exports